console.log('product-panel.js loaded');


var loaded = false;

// Función para inicializar el panel cuando se hace clic en un botón
function initializePanelOnClick() {
    const toggleBtns = document.querySelectorAll('.toggle-panel');

    toggleBtns.forEach(function (toggleBtn) {
        const parent = toggleBtn.parentNode;
        parent.style.display = 'flex';

        toggleBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            const productId = toggleBtn.getAttribute('data-product-id');
            initializePanel(productId, toggleBtn, event.target);
           
        });

        loaded = true;
    });
}


function observeDOMChanges() {
    var observer = new MutationObserver(function (mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Itera sobre los nodos agregados en la mutación
                mutation.addedNodes.forEach(function (node) {
                 
                    // Verifica si el nodo agregado tiene la clase .swiper
                    if (node.classList && node.classList.contains('ProductList') || node.classList && node.classList.contains('Accordion__Item')) {
                        // Si se agregó un elemento con la clase .swiper, inicializa los Swipers nuevamente
                        initializePanelOnClick();
                    }
                });
                // Itera sobre los nodos eliminados en la mutación
                mutation.removedNodes.forEach(function (node) {
                    // Verifica si el nodo eliminado tiene la clase .swiper
                    if (node.classList && node.classList.contains('ProductList') || node.classList && node.classList.contains('Accordion__Item')) {
                        // Si se eliminó un elemento con la clase .swiper, vuelve a inicializar los Swipers
                        initializePanelOnClick();
                    }
                });
            }
        }
    });

    // Observa cambios en todo el documento
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
    });
}

observeDOMChanges()


document.addEventListener('DOMContentLoaded', function () {
    const toggleBtns = document.querySelectorAll('.toggle-panel');

    toggleBtns.forEach(function (toggleBtn) {
        const parent = toggleBtn.parentNode;
        parent.style.display = 'flex';

        toggleBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            const productId = toggleBtn.getAttribute('data-product-id');
            initializePanel(productId, toggleBtn, event.target);
        });
    });
});

// Event listener para inicializar el panel cuando se agregan nuevos botones al documento
const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        const newNode = mutation.addedNodes[0];
        if (newNode.classList && newNode.classList.contains('ProductList')) {
          initializePanelOnClick();
        }
      }
    });
  });
  
  observer.observe(document.body, { childList: true });
  

function initializePanel(productId, panelButton, panelOrig) {
    var panel = document.querySelectorAll('.panel-sizes--' + productId);

    if (panel.length > 1) {
        panel[1].remove();
    }else {
        panel = panel[0];
    }

    var   toggleBtn = panelButton
    const allPanels = document.querySelectorAll('.panel-sizes');
    const addToCartBtn = document.getElementById('addToCart--' + productId);
    const listItems = document.querySelectorAll('.ListFilterSize--' + productId + ' li');
    var selectedVariantId = null;
    const inputVariant = document.querySelector('.ProductForm__SelectedVariantId--' + productId);

    document.body.appendChild(panel);

    let originalPosition = {}; // Almacenar la posición original del panel


    allPanels.forEach(function (p) {
        if (p.classList.contains('active') && p !== panelOrig) {
            p.classList.remove('active');
        }});

    // Mostrar y ocultar el panel al hacer clic en el botón
    if (panel.classList.contains('active')) {
        panel.classList.remove('active');
        restoreOriginalPosition(panel); // Restaurar la posición original cuando se cierra el panel
    } else {
        panel.classList.add('active');
        adjustPanelPosition(productId); // Ajustar la posición del panel cuando se abre
    }

    // Agregar event listener al botón de agregar al carrito dentro del panel
    addToCartBtn.addEventListener('click', function (event) {
        
    });

    // Agregar event listener a los elementos de la lista dentro del panel
    listItems.forEach(function (item) {
        item.addEventListener('click', function () {
            listItems.forEach(function (li) {
                li.classList.remove('Active');
            });
            item.classList.add('Active');
            selectedVariantId = item.getAttribute('data-value');
            inputVariant.value = selectedVariantId;
        });
    });

    // Agregar event listener para cerrar el panel si se hace clic fuera de él
    document.addEventListener('click', function (event) {
        const isClickInsidePanel = panel.contains(event.target);
        const isClickInsideToggleBtn = toggleBtn.contains(event.target);

        if (!isClickInsidePanel && !isClickInsideToggleBtn) {
            panel.classList.remove('active');
            restoreOriginalPosition(panel);
        }
    });

    // Función para almacenar la posición original del panel
    function saveOriginalPosition() {
        originalPosition = {
            top: panel.style.top,
            bottom: panel.style.bottom,
            left: panel.style.left,
            right: panel.style.right
        };
    }

    // Función para restaurar la posición original del panel
    function restoreOriginalPosition(panel) {
        panel.style.top = originalPosition.top || '';
        panel.style.bottom = originalPosition.bottom || '';
        panel.style.left = originalPosition.left || '';
        panel.style.right = originalPosition.right || '';
        panel.style.margin = '0px';
    }

    // Función para ajustar la posición del panel
    function adjustPanelPosition(productId) {
        const toggleBtn = panelButton
        const rectToggleBtn = toggleBtn.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const iconWidthOrigin = document.querySelector('.toggle-panel--' + productId + ' svg').getBoundingClientRect().width || 0;
        const iconPadding = 4;
        const iconWidth = iconWidthOrigin ? iconWidthOrigin + iconPadding : 0;

        let leftPos = rectToggleBtn.left + window.scrollX;
        let topPos = rectToggleBtn.bottom + window.scrollY;

        // Verificar si hay espacio suficiente en el viewport para el panel
        const noViewportSpace = iconPadding + leftPos + panel.offsetWidth > viewportWidth;

        // Ajustar la posición horizontal del panel según la disponibilidad del espacio en el viewport
        if (noViewportSpace) {
            panel.style.left = (leftPos - panel.offsetWidth / 1.33) + iconWidth + 'px';
        } else {
            panel.style.left = (leftPos) + 'px';
        }

        panel.style.top = (topPos + 16) + 'px';

        panel.scrollIntoView({ behavior: 'smooth', block: 'center' }); // Desplazar al panel

        // Guardar la posición original del panel
        saveOriginalPosition();
    }

    // Función para ajustar la posición del panel cuando se redimensiona la ventana
    window.addEventListener('resize', function () {
        if (panel.classList.contains('active')) {
            adjustPanelPosition(productId);
        }
    });

    // Ajustar la posición del panel cuando se carga la página
    adjustPanelPosition(productId);
}
